module.exports = __webpack_public_path__ + "img/63.d71bcaf9.png";